import { fetch } from '@atlassian/eoc-fetch';
import { UrlHelper } from '../../../common/utils/url-helper';
import { LIMIT } from './constants';
const getIntegrations = async (query, pathParamTeamId) => {
  const page = parseInt(query['page']) || 1;
  const offset = (page - 1) * LIMIT;
  const queryParams = query ? {
    teamId: pathParamTeamId !== null && pathParamTeamId !== void 0 ? pathParamTeamId : query.teamId,
    group: query.group,
    keyword: query.keyword,
    status: query.status
  } : {};
  return fetch(UrlHelper('/v3/integrations/unified', {
    ...queryParams,
    offset: offset.toString(),
    // UrlHelper omits 0 as number since it is a falsy value
    limit: LIMIT
  })).then(response => ({
    data: response.data.integrations,
    pageCount: Math.ceil(response.data.count / LIMIT),
    itemCount: response.data.count,
    platformTeamId: response.data.platformTeamId
  }));
};
const patchIntegration = async (integrationId, integrationType, body, teamId) => fetch(UrlHelper(`/v3/integrations/unified/${integrationId}`, {
  type: integrationType,
  teamId
}), {
  method: 'PATCH',
  body
}).then(response => response.data);
const deleteIntegration = async (integrationId, integrationType, teamId) => fetch(UrlHelper(`/v3/integrations/unified/${integrationId}`, {
  type: integrationType,
  teamId
}), {
  method: 'DELETE',
  responseType: 'headers'
});
export default {
  getIntegrations,
  patchIntegration,
  deleteIntegration
};